import { $authHost } from ".."

export const getGoodTypesAllAPI = async () => {
    const {data} = await $authHost.get(`api/products/good_types/all`)
    return data
}